<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { cn } from '../../../lib/utils'
import {useFormField} from "../form/useFormField";

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

// @ts-ignore using any because there is a typing error here, seemingly caused by our config, that I cannot resolve
const modelValue: any = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const { error } = useFormField();

</script>

<template>
  <textarea
    v-model="modelValue"
    :class="
      cn(
        `
          inline-flex min-h-[5rem] w-full border bg-[color:var(--theme-background-color)] px-[12px] py-[8px] text-sm
          outline-none focus:border-[color:var(--input-active-border)]
          disabled:cursor-not-allowed disabled:opacity-50 border-[color:var(--input-primary-border)]
          text-[color:var(--theme-text-color)]
        `,
        error && 'border-[color:var(--theme-highlight-color)]',
      )
    "
  />
</template>
